export default {
    LOAD_NAME_BUDGET(state, data) {
        state.items = data;
    }
}